const prefix = "/label/api";

module.exports = {
    httpApiPrefixPath: prefix
};
